"use client";

import { Reveal } from "./Reveal";
import { MAISON } from "@/lib/diwline-data";
import { Droplets } from "lucide-react";

export function SursautNourricier() {
  return (
    <section
      id="sursaut"
      className="relative overflow-hidden bg-gradient-to-b from-royal via-bordeaux-deep/55 to-royal py-28 md:py-40"
      aria-label="Le Sursaut Nourricier"
    >
      {/* Halos dorés */}
      <div className="pointer-events-none absolute inset-0" aria-hidden>
        <div className="absolute -top-24 left-1/4 h-72 w-72 rounded-full bg-gold/8 blur-3xl" />
        <div className="absolute -bottom-24 right-1/4 h-72 w-72 rounded-full bg-gold/8 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-gold/50 bg-royal shadow-[0_0_40px_rgba(212,175,55,0.25)]">
            <Droplets className="h-7 w-7 text-gold" aria-hidden />
          </span>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-8 font-elegant text-xs uppercase tracking-[0.5em] text-gold/85">
            XII — Le Sursaut Nourricier
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <blockquote className="mt-8 font-display text-2xl md:text-4xl font-medium italic leading-snug text-cream">
            « Que chaque goutte d&apos;or liquide qui coule de nos huileries porte la générosité de
            la terre africaine et la bienveillance de la Nation.{" "}
            <span className="text-gold-gradient animate-shimmer not-italic">
              Le Sénégal nourrira l&apos;Afrique, l&apos;Afrique nourrira le monde.
            </span>{" "}
            »
          </blockquote>
        </Reveal>

        <Reveal delay={0.35}>
          <p className="mt-10 font-display text-lg font-semibold text-gold-light">
            {MAISON.souveraine}
          </p>
          <p className="mt-2 text-xs uppercase tracking-[0.35em] text-cream/55">
            {MAISON.fondation} · {MAISON.ville}
          </p>
          <p className="mt-6 font-elegant text-lg italic text-gold/85">« {MAISON.devise} »</p>
        </Reveal>
      </div>
    </section>
  );
}
